const Opiniones = () => {
    return (
        <div
            className="w-full h-screen bg-cover bg-center flex items-center justify-start"
        >
            <div className="w-full text-white px-4 md:px-44 text-center grid grid-cols-1 gap-4 md:gap-12">
                <div>
                    <h2 className="text-4xl text-estra">Por qué la gente confía en nosotros</h2>
                </div>
                <div className="h-1 w-full bg-yellow-400" />
                <div className="text-sky-900">
                    <p className="text-right">Jueves 7 de Abril , 2022</p>
                    <h2 className="text-2xl font-bold">" La asesoría contable que nos brindaron nos ayudó mucho en nuestras declaraciones de impuestos "</h2>
                </div>
                <div className="text-gray-500">
                    <p className="text-lg">Rodrigo Sánchez</p>
                    <p className="text-lg">Administrador de Empresas, Puebla</p>
                </div>
            </div>
        </div>
    );
};

export default Opiniones;